import {useSelector} from 'react-redux'
import CancelButton from './CancelButton'
import EditProducts from './EditProducts'
import SaveButton from './SaveButton'
import {useNavigate} from 'react-router-dom'
import {RootState} from 'setup'
import {selectIsProductsEditMode} from 'app/features/orders/redux/order/orderEditSlice'

export const EditActionWrapper = () => {
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)
  const history = useNavigate()

  const handleClick = () => {
    history(-1)
  }

  return (
    <div className='d-flex justify-content-end align-items-center flex-row mt-5'>
      {/* {isProductMode ? ( */}
      <>
        <CancelButton onClick={handleClick} title='Cancel' />
        <SaveButton />
      </>
      {/* ) : (
        <>
          <EditProducts />
          <CancelButton onClick={handleClick} />
        </>
      )} */}
    </div>
  )
}

export default EditActionWrapper
